var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',_vm._b({attrs:{"items":_vm.options},on:{"change":_vm.onChange},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}},'v-select',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }